const ActionTypes = {
  SET_LANGUAGE: "SET_LANG",
  SET_LANGUAGES: "SET_LANGS",
  CHANGE_MARKET_LAYOUT: "CHANGE_MARKET_LAYOUT",
  CHANGE_PUSH_NOTIFICATIONS: "CHANGE_PUSH_NOTIFICATIONS",
}

export default ActionTypes;
